var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"title":_vm.title,"showBack":true}}),(_vm.ContractUrl!='')?_c('iframe',{attrs:{"src":_vm.ContractUrl,"width":"100%","height":"900px"}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }